import { AnimatePresence, motion } from "framer-motion";
import { bool, object, string } from "prop-types";
import React from "react";

import Typography from "@components/shared/Typography";

import { useGetFormattedPrice } from "@hooks/useGetFormattedPrice";

const DealSummaryMinimalItem = props => {
  const { isVisible, item, type } = props;
  const getFormattedPrice = useGetFormattedPrice();

  return (
    <AnimatePresence initial={false}>
      {isVisible && (
        <motion.div
          animate="open"
          className="flex items-center"
          exit="collapsed"
          initial="collapsed"
          variants={{
            open: {
              opacity: 1,
              height: "auto",
              display: "flex",
            },
            collapsed: {
              opacity: 0,
              height: 0,
              transitionEnd: { display: "none" },
              transition: { duration: 0.3, type: "tween" },
            },
          }}
        >
          <div className="flex flex-col flex-1-1-0 ml-4">
            <Typography
              className="font-semibold uppercase"
              data-id={`deal-summary-item-name-${type}`}
            >
              {item.label}
            </Typography>
          </div>
          <Typography
            className="font-semibold uppercase"
            data-id={`deal-summary-item-price-${type}`}
          >
            {item.netPrice ? getFormattedPrice(item.netPrice) : ""}
          </Typography>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

DealSummaryMinimalItem.propTypes = {
  isVisible: bool.isRequired,
  item: object.isRequired,
  type: string.isRequired,
};

export default DealSummaryMinimalItem;
